import { useEffect, useRef, useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import para from "../../json/ParagraphStyle.json";
import char from "../../json/CharacterStyle.json";
import { toast } from "react-toastify";
import { applyParaStyles } from "../../Utility/ParaStyles";

const Styles = ({ editor, show, currentStyle, handleCancel, initialized }) => {
  const [data, setData] = useState("");
  const [currentChoice, setCurrentChoice] = useState(null);
  const [searchInput, setSearchInput] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [currentTag, setCurrentTag] = useState("");
  const inputRef = useRef(null);
  const modalRef = useRef(null);
  const [nodeType, setNodeType] = useState("");

  // Ensure input field retains focus after clicking a button
  useEffect(() => {
    const handleModalClick = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    // Add the click event listener to the modal
    if (modalRef.current) {
      modalRef.current.addEventListener("click", handleModalClick);
    }

    // Focus the input when the modal is opened
    // if (show && inputRef.current) {
    //   inputRef.current.focus();
    // }

    // Cleanup
    return () => {
      if (modalRef.current) {
        modalRef.current.removeEventListener("click", handleModalClick);
      }
    };
  }, [show, modalRef.current, currentTag, currentChoice]);

  useEffect(() => {

    const handleClick = (e) => {

      if (currentStyle === "ParaStyle") {
        const node = editor?.selection.getNode();
        const getParent = (node) => {
          if (!node || !node.parentNode) return null;

          const tagName = node.parentNode.tagName;
          const validTags = ["FRONT", "BODY1", "BACK", "REF-LIST"];

          if (validTags.includes(tagName)) {
            return tagName;
          }

          return getParent(node.parentNode);
        };

        const current = getParent(node);
        if (current === "FRONT") setCurrentTag("FM");
        else if (current === "BODY1") setCurrentTag("BODY");
        else if (current === "REF-LIST") setCurrentTag("REFERENCE");
        else if (current === "BACK") setCurrentTag("BACK");
      } else {
        setCurrentTag("AllStyles");
      }
    };

    editor?.on("click", handleClick);

    return () => editor?.off("click", handleClick);
  }, [editor, initialized, show, currentStyle]);


  useEffect(() => {
    if (currentStyle === "ParaStyle") {
      setData(para);
    } else {
      setData(char);
    }
  }, [currentStyle]);

  useEffect(() => {
    if (data) {
      setCurrentTag(Object.keys(data)[0]);
    }
  }, [data]);

  useEffect(() => {
    filterData();
  }, [data, currentChoice, searchInput]);

  const renderBtn = () => {
    // return Object.keys(data)?.map((item, i) => (
    //   <button
    //     key={i}
    //     className={`px-2  ${currentTag === item ? "bg-blue-500  text-white" : "bg-gray-300"
    //       }`}
    //     onClick={(e) => {
    //       e.preventDefault();
    //       setCurrentTag(e.target.value);
    //     }}
    //     disabled={currentStyle === "ParaStyle" && item !== currentTag}
    //     value={item}
    //   >
    //     {item}
    //   </button>
    // ));
    return (
      <select
        value={currentTag}
        onChange={(e) => setCurrentTag(e.target.value)}
        className="px-2 py-1 border border-gray-300 rounded-md outline-none w-full"
        
      >
        {Object.keys(data)?.map((item, i) => (
          <option key={i} value={item} disabled={currentStyle === "ParaStyle" && item !== currentTag}>
            {item}
          </option> 
        ))}
      </select> 
    );
  };

  const filterData = () => {
    let filteredData = searchInput
      ? data[currentTag]?.filter((item) =>
        item.name.toLowerCase().includes(searchInput.toLowerCase())
      )
      : data[currentTag];
    setFilteredData(filteredData);
  };

  useEffect(() => {
    renderBtn();
    filterData();
  }, [show, currentTag, editor.selection]);

  const handleStyle = (e, list) => {
    const node = editor?.selection.getNode();

    if (currentStyle === "ParaStyle") {
      if (node) {
        const tagName = node.tagName?.toLowerCase();
 
        // if (tagName === list.tag.toLowerCase()) {
        //   toast.info("Already applied.");
        //   return;
        // }
        const response = applyParaStyles(node, editor, list);
        if (response.success) {
          toast.success(response.message);
        } else {
          toast.warn(response.message);
        }
      }
    } else {
      const selectedHtml = editor.selection.getContent({ format: "html" });
      const selectedText = editor.selection.getContent({ format: "text" });
      const parent = editor.selection.getNode();

      const parentText = parent.textContent.trim();
      const isWholeTagSelected = parentText === selectedText.trim();

      let template;
      let givenname;
      let surname;

      if (selectedText) {
        if (selectedText.includes(" ")) {
          let name = selectedText.trim().split(" ");

          givenname = name[0];
          surname = name[1];
        }
      }

      if (list.tag === "contrib") {
        template = `<contrib contrib-type="author">
        <contrib-id contrib-id-type="orcid"></contrib-id> 
        <name name-style="western">
        <surname>${surname}</surname>
        <given-name>${givenname}</given-name>
        </name>
        </contrib>`;
      } else {
        template = `<${list.tag} ${list.tag.includes("ext-link")
          ? `xlink:href='http://${selectedText.trim()}'`
          : ""
          } data-attr="${list.attr}"> ${isWholeTagSelected ? selectedText : selectedHtml
          } </${list.tag}`;
      }

      if (isWholeTagSelected) {
        // Replace the entire tag
        const newTagHtml = template;
        parent.outerHTML = newTagHtml;
        toast.success("Character style replaced");
      } else {
        // Wrap only the selected content
        const wrappedHtml = template;
        editor.selection.setContent(wrappedHtml);
        toast.success("Character style applied");
      }
    }
  };

  return (
    <>
      <div className="border-b border-grey p-3 absolute top-0 bg-leftPanelbg inset-x-0 ">
        <h4 className="font-semibold text-primary text-[18px]">
          {currentStyle === "ParaStyle"
            ? "Paragraph styles"
            : "Character styles"}
        </h4>
      </div>
      <div className="w-full flex flex-col p-2 gap-4 mt-14 h-full ">
        <div className="flex flex-wrap gap-y-4 gap-x-2">{renderBtn()}</div>
        <div className="w-full">
          <div className="relative w-full max-w-[400px] flex items-center">


            <span className="absolute left-3 text-gray-400 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-4.35-4.35m1.35-5.15a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </span>

            <input
              ref={inputRef}
              type="search"
              placeholder="Search styles..."
              value={searchInput || ""}
              onChange={(e) => setSearchInput(e.target.value)}
              className="w-full pl-9 pr-8 py-2 border border-gray-300 rounded-md 
               outline-none focus:ring-2 focus:ring-blue-400 
               focus:border-blue-400 transition"
            />

            {searchInput && (
              <button
                onClick={() => setSearchInput("")}
                className="absolute right-2 text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            )}

          </div>
        </div>
        <div className="flex flex-col w-full h-full p-3 bg-white max-h-[calc(100%-104px)] border border-grey  overflow-auto right-panel-scroll">
          {filteredData?.map((list, i) => (
            <button
              onClick={(e) => handleStyle(e, list)}
              key={i}
              className="text-left  hover:text-18 hover:text-blue-500 border border-gray rounded-md p-2 mb-2"
              value={list.name}
            >
              {list.name}
            </button>
          ))}
        </div>
      </div>
      <div className="absolute bottom-[5px] mr-[40px] inset-x-0 w-full flex justify-end">
        <button
          onClick={handleCancel}
          className=" bg-[#0060CE] text-white px-4 py-1.5 text-sm rounded-md hover:bg-[#004fa8] transition mr-[18px]"
        >
          Close
        </button>
      </div>
    </>
  );
};
export default Styles;
